import FormSelect from 'components/Select/FormSelect';
import { ISelectOption } from 'components/Select/types';
import { restaurantNotificationEvents } from 'appConstants';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const PushTypeSelect: React.FC = () => {
	const { t } = useTranslation('form');

	const mappedOptions = useMemo<ISelectOption[]>(() => {
		return restaurantNotificationEvents.map((el) => ({
			id: el,
			name: t(el),
		}));
	}, [t]);

	return (
		<FormSelect
			testId="PushTypeSelect"
			name="pushType"
			label="pushTypeLabel"
			options={mappedOptions}
			withSearch={true}
			disabled={true}
		/>
	);
};

export default React.memo(PushTypeSelect);
